import { jsx as _jsx } from "react/jsx-runtime";
import { logError } from "@faire/web--source/common/logging";
import React, { useContext, useEffect } from "react";
import styled, { css } from "styled-components";
import { accordionTransitionTiming } from "./Accordion";
import { AccordionContext } from "./context";
/**
 * A component that animates the rotation of its children according to the state
 * of the parent accordion.
 */ export var AnimatedChevronContainer = function(param) {
    var children = param.children, isDisplayFlex = param.isDisplayFlex, onTransitionEnd = param.onTransitionEnd;
    var context = useContext(AccordionContext);
    useEffect(function() {
        if (context === null) {
            logError("Trying to use AccordionContext outside of a provider");
        }
    }, [
        context
    ]);
    return /*#__PURE__*/ _jsx(AnimationContainer, {
        $rotateDegrees: context ? -90 : 90,
        onTransitionEnd: onTransitionEnd,
        $isDisplayFlex: isDisplayFlex,
        children: children
    });
};
var AnimationContainer = styled.span.withConfig({
    componentId: "sc-5ee268b0-0"
})([
    "transform:rotate( ",
    " );display:",
    ";transition-property:transform;",
    ""
], function(props) {
    return css([
        "",
        "deg"
    ], props.$rotateDegrees);
}, function(props) {
    return props.$isDisplayFlex ? "flex" : "inline-block";
}, accordionTransitionTiming);
